<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>CONTACT</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Contact</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>

<!-- QUICK CONTACT
================================================== -->
<section class="contact-form pb-0">
    <div class="container mb-2-9 mb-md-6 mb-lg-7">
        <div class="section-heading">
            <span class="sub-title">OUR CONTACTS</span>
            <h2 class="mb-9 display-16 display-sm-14 display-lg-10 font-weight-800">We`re here to Help You</h2>
            <div class="heading-seperator"><span></span></div>
        </div>
        <div class="row mt-n2-9 mb-md-6 mb-lg-7">
            <div class="col-lg-4 mt-2-9">
                <div class="contact-wrapper bg-light rounded position-relative h-100 px-4">
                    <div class="mb-4">
                        <i class="contact-icon ti-email"></i>
                    </div>
                    <div>
                        <h4>Email Here</h4>
                        <ul class="list-unstyled p-0 m-0">
                            <li><a href="#!"> arni.in</a></li>
                            <li><a href="#!">info@arni.in</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 mt-2-9">
                <div class="contact-wrapper bg-light rounded position-relative h-100 px-4">
                    <div class="mb-4">
                        <i class="contact-icon ti-map-alt"></i>
                    </div>
                    <div>
                        <h4>Location Here</h4>
                        <ul class="list-unstyled p-0 m-0">
                            <li>Arni University, (Kathgarh),Tehsil Indora,
                                Distt. Kangra,Himachal Pradesh Pin-176401
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 mt-2-9">
                <div class="contact-wrapper bg-light rounded position-relative h-100 px-4">
                    <div class="mb-4">
                        <i class="contact-icon ti-mobile"></i>
                    </div>
                    <div>
                        <h4>Call Here</h4>
                        <ul class="list-unstyled p-0 m-0">
                            <li><a href="#!">78-7684-8080</a></li>
                            <li><a href="#!">78-7685-9292</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- CONTACT FORM
================================================== -->
<section class="bg-very-light-gray py-md-8 pb-lg-0">
    <div class="container">
        <div class="row align-items-end">
            <div class="col-lg-6 d-none d-lg-block">
                <img src="assets/img/content/contact-img-01.jpg" alt="...">
            </div>
            <div class="col-lg-6">
                <div class="faq-form">
                    <h2 class="mb-4 text-primary">Get In Touch</h2>
                    <form [formGroup]="contactForm" class="contact quform" action="https://elearn.websitelayout.net/quform/contact.php"
                          method="post" enctype="multipart/form-data" onclick="">
                        <div class="quform-elements">
                            <div class="row">

                                <!-- Begin Text input element -->
                                <div class="col-md-6">
                                    <div class="quform-element form-group">
                                        <label for="name">Your Name <span class="quform-required">*</span></label>
                                        <div class="quform-input">
                                            <input class="form-control" id="name" type="text" formControlName="name"
                                                   placeholder="Your name here"/>
                                        </div>
                                    </div>
                                </div>
                                <!-- End Text input element -->

                                <!-- Begin Text input element -->
                                <div class="col-md-6">
                                    <div class="quform-element form-group">
                                        <label for="email">Your Email <span class="quform-required">*</span></label>
                                        <div class="quform-input">
                                            <input class="form-control" id="email" type="text" formControlName="email"
                                                   placeholder="Your email here"/>
                                        </div>
                                    </div>
                                </div>
                                <!-- End Text input element -->

                                <!-- Begin Text input element -->
                                <div class="col-md-6">
                                    <div class="quform-element form-group">
                                        <label for="subject">Your Subject <span class="quform-required">*</span></label>
                                        <div class="quform-input">
                                            <input class="form-control" id="subject" type="text" formControlName="subject"
                                                   placeholder="Your subject here"/>
                                        </div>
                                    </div>
                                </div>
                                <!-- End Text input element -->

                                <!-- Begin Text input element -->
                                <div class="col-md-6">
                                    <div class="quform-element form-group">
                                        <label for="phone">Contact Number</label>
                                        <div class="quform-input">
                                            <input class="form-control" id="phone" type="text" formControlName="contact"
                                                   placeholder="Your phone here"/>
                                        </div>
                                    </div>
                                </div>
                                <!-- End Text input element -->

                                <!-- Begin Textarea element -->
                                <div class="col-md-12">
                                    <div class="quform-element form-group">
                                        <label for="message">Message <span class="quform-required">*</span></label>
                                        <div class="quform-input">
                                            <textarea class="form-control" id="message" formControlName="message" rows="3"
                                                      placeholder="Tell us a few words"></textarea>
                                        </div>
                                    </div>
                                </div>
                                <!-- End Textarea element -->

                                <!-- Begin Submit button -->
                                <div class="col-md-12">
                                    <div class="quform-submit-inner">
                                        <button class="butn secondary" type="submit" (click)="submit()"><i
                                            class="far fa-paper-plane icon-arrow before"></i><span class="label">Send Message</span><i
                                            class="far fa-paper-plane icon-arrow after"></i></button>
                                    </div>
                                    <div class="quform-loading-wrap text-start"><span class="quform-loading"></span>
                                    </div>
                                </div>
                                <!-- End Submit button -->

                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- MAP
================================================== -->
<section class="p-0">
    <iframe width="100%" height="500" id="gmap_canvas"
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d108146.20127408486!2d75.660187!3d32.107938!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x391b833726246e79%3A0x3bf590ddee96ab2c!2sArni%20University!5e0!3m2!1sen!2sin!4v1728277072433!5m2!1sen!2sin"></iframe>
</section>
